const text_49 = {
    intervention: 49,
    description_short: "Verbeter je stemming in slechts één sessie.",
    step_2_title: "",
    description_part1: "",
    description_part2: "",
    description_part3: "",
  }
  
  export {text_49};